export enum LocizeAppName {
  MANAGER = 'MANAGER',
  PRE_INSPECTION = 'PRE_INSPECTION',
  COMMON = 'COMMON',
}
